import styles from './table2phone.module.scss'

export default (props) => {
  const { columns = [], dataSource = [] } = props || {}

  const renderColumns = (r) => {
    return (
      <div className={styles.a}>
        {columns.map((_) => (
          <div className={styles.aa} key={_.dataIndex}>
            <span className={styles.aat}>{_.title}</span>
            <span>{_.render ? _.render(r[_.dataIndex]) : r[_.dataIndex]}</span>
          </div>
        ))}
      </div>
    )
  }

  return <>{dataSource.map((_) => renderColumns(_))}</>
}
